module.exports = __webpack_public_path__ + "img/resource-ya-active.c9d25b29.png";